// extracted by mini-css-extract-plugin
export default {"breadcrumb":"PageWrapper-module--breadcrumb--84f43"};